module.exports = __webpack_public_path__ + "static/media/Review_CBCT_tab.55011ce0.jpg";